import * as types from './types';

export default {
    [types.SET_USER_TYPE](state, data) {
        state.userType = data;
    },
    [types.SET_USER_COUNTRY](state, data) {
        state.userCountry = data;
    }
};